import script from "./administrasi.vue?vue&type=script&setup=true&lang=ts"
export * from "./administrasi.vue?vue&type=script&setup=true&lang=ts"

import "./administrasi.vue?vue&type=style&index=0&id=55176704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55176704"]])

export default __exports__